import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-people-disable-selected",
  "use": "icon-people-disable-selected-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-people-disable-selected\">\r\n  <g id=\"icon-people-disable-selected_组_87\" data-name=\"组 87\" transform=\"translate(-12 -446)\">\r\n    <path id=\"icon-people-disable-selected_路径_12053\" data-name=\"路径 12053\" d=\"M12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Z\" transform=\"translate(12 446)\" fill=\"#333\" opacity=\"0.1\" />\r\n    <path id=\"icon-people-disable-selected_路径_12034\" data-name=\"路径 12034\" d=\"M4862.128,2738.635l3.87,3.869,6.729-6.864\" transform=\"translate(-4843.428 -2281.073)\" fill=\"none\" stroke=\"#999\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/people-disable-selected.svg
// module id = gVpl
// module chunks = 3